import {BiReset} from "react-icons/bi";
import {Accordion, Button, ColorPicker} from "../../../../components";
import {useViewerStore} from "../../../../store/store";
import {Alert, Tooltip} from "antd";
import {roofTextureList} from "../../../../Constants";

const RoofShingles: React.FC = () => {

    const roofSelectedColor = useViewerStore((state) => state.roofSelectedColor);
    const sceneViewer = useViewerStore((state) => state.sceneViewer);

    const resetRoofShingleHandler = () => sceneViewer.resetRoofToDefault();

    const roofShingleHandler = (e: React.MouseEvent<HTMLImageElement>) => {
        // Remove active class from all .pattern__img elements
        const li = document.querySelectorAll('.pattern__img');
        li.forEach((item) => {
            item.classList.remove('active');
        });

        const target = e.target as HTMLImageElement;
        const parent = target.parentNode as HTMLElement;
        parent.classList.add('active');

        sceneViewer.setMeshTexture(
            sceneViewer.roofMeshArr,
            target.src,
            "roof",
            parent.title
        );
    };

    const roofColorChangeHandler = (color: string) => {
        useViewerStore.setState({roofSelectedColor: color});
        sceneViewer.setMeshMaterialColor(sceneViewer.roofMeshArr, color);
    };

    return (
        <>
            <div className="tab__inner">
                <div className="tab__title">
                    <span className="tab__title--text">Roof Shingles</span>
                    <div className="tab__title--btns">
                        <Button
                            onClick={resetRoofShingleHandler}
                            variant="btn-clear"
                            size="btn-resize"
                            title={'Reset to Default'}
                        >
                            <BiReset />
                        </Button>
                    </div>
                </div>

                <div className="tab__column">
                    <Accordion title="Select Roof Shingle" active={true}>
                        <ul className="pattern">
                            {roofTextureList.map((item, index) => (
                                <li className="pattern__item" key={index}>
                                        <Button
                                            variant="btn-clear"
                                            size="btn-resize"
                                            className="pattern__img"
                                        >
                                        <Tooltip
                                            mouseLeaveDelay={0.001}
                                            mouseEnterDelay={0.05}
                                            destroyTooltipOnHide={{keepParent : false}}
                                            placement="left"
                                            title={<>
                                                {item.alt}
                                                <br/>
                                                {item.name}
                                            </>}>
                                                <img src={item.img} onClick={roofShingleHandler}/>
                                        </Tooltip>
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </Accordion>
                </div>

                <div className="tab__column">
                    <div className="tab__flex justify-between mb-1">
                        <span className="tab__column--subtitle">Roof Color</span>
                        <ColorPicker
                            currentColor={roofSelectedColor}
                            changeHandler={roofColorChangeHandler} />
                    </div>
                    <Alert 
                        className="tab__color-picker-alert"
                        message="Dark mode extensions may cause unexpected behavior with the color picker. Please disable any related extensions and use oneDRAW's built-in dark mode to proceed."
                        type='warning'
                        showIcon
                    />
                    <div className="tab__flex justify-start gap-0"></div>
                </div>
            </div>
        </>
    );
};

export default RoofShingles;
